import { makeStyles, tokens } from '@fluentui/react-components';

import { HomePageAssets } from './constants';

export const useStyle = makeStyles({
  container: {
    overflowY: 'auto',
    height: '100%',
    width: '100%',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  inner: {
    maxWidth: '100%',
  },
  hero: {
    position: 'relative',
  },
  heroImage: {
    backgroundImage: `linear-gradient(to right, color-mix(in srgb, ${tokens.colorNeutralBackground1} 75%, transparent), color-mix(in srgb, ${tokens.colorNeutralBackground1} 25%, transparent)), linear-gradient(to bottom, transparent, color-mix(in srgb, ${tokens.colorNeutralBackground1} 75%, transparent)), linear-gradient(to bottom, transparent 50%, ${tokens.colorNeutralBackground1}), url(${HomePageAssets.hero})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '272px',
    minWidth: '272px',
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  heroImageDark: {
    backgroundImage: `linear-gradient(to right, color-mix(in srgb, ${tokens.colorNeutralBackground1} 75%, transparent), color-mix(in srgb, ${tokens.colorNeutralBackground1} 25%, transparent)), linear-gradient(to bottom, transparent, color-mix(in srgb, ${tokens.colorNeutralBackground1} 75%, transparent)), linear-gradient(to bottom, transparent 50%, ${tokens.colorNeutralBackground1}), url(${HomePageAssets.heroDark})`,
  },
  heroText: {
    padding: '60px 0px 20px 40px',
  },
  heroTitle: {
    fontSize: '24px',
    margin: 0,
  },
  heroSubtitle: {
    paddingTop: '8px',
    fontSize: '14px',
  },
  feed: {
    boxSizing: 'border-box',
    height: '100%',
    padding: '40px',
    gap: '40px',
  },
  resources: {
    padding: '0px 32px 40px 40px',
    paddingTop: '0px',
    paddingRight: '32px',
    paddingBottom: '40px',
    paddingLeft: '40px',
  },
  resourceTitle: {
    lineHeight: '24px',
  },
  resourceSubtitle: {
    lineHeight: '20px',
  },
});
